import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _typeof from "@babel/runtime/helpers/typeof";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;

import { debounce } from 'lodash-es';
import React, { Children, useEffect, useMemo, useRef, useState } from 'react';
import styled from 'styled-components';
import { ResetButton } from './Button';
import Space from './Space';
var SideNavigation = styled.ol(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: fixed;\n  padding: 1rem;\n  counter-reset: dialog-with-side-navigation-counter;\n  list-style: none;\n  top: 4rem;\n  left: 2rem;\n"])));
var SideNavigationItem = styled.li(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  counter-increment: dialog-with-side-navigation-counter;\n  opacity: ", ";\n  font-weight: ", ";\n  cursor: ", ";\n\n  &:not(:last-child) {\n    margin-bottom: 1.5rem;\n  }\n\n  &::before {\n    content: counter(dialog-with-side-navigation-counter);\n    display: inline-block;\n    width: 1.5rem;\n    height: 1.5rem;\n    text-align: center;\n    margin-right: 0.5rem;\n    background-color: ", ";\n    color: ", ";\n    border-radius: 100%;\n  }\n"])), function (props) {
  return props.active ? 1 : 0.25;
}, function (props) {
  return props.active ? 'bold' : 'normal';
}, function (props) {
  return props.disabled ? 'not-allowed' : 'pointer';
}, function (props) {
  return props.theme.colors.dark;
}, function (props) {
  return props.theme.colors.light;
});
SideNavigationItem.defaultProps = {
  active: false,
  anchorMenu: [],
  disabled: false
};
var SideNavigationAnchorContainer = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  margin-left: 2rem;\n  margin-top: 0.5rem;\n"])));
var SideNavigationAnchorItem = styled(ResetButton)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  cursor: pointer;\n  padding: 0.5rem;\n  border-radius: 0.255rem;\n  background-color: ", ";\n  font-weight: ", ";\n  opacity: ", ";\n  transition: all 0.3s ease-in;\n  text-align: left;\n\n  &:not(:last-child) {\n    margin-bottom: 0.5rem;\n  }\n\n  &:hover {\n    background-color: ", ";\n  }\n"])), function (props) {
  return props.active ? props.theme.colors.grey : 'none';
}, function (props) {
  return props.active ? 'bold' : 'normal';
}, function (props) {
  return props.active ? 1 : 0.25;
}, function (props) {
  return props.theme.colors.grey;
});
var SideNavigationContainer = styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n"])));

var WithSideNavigation = function WithSideNavigation(_ref) {
  var children = _ref.children,
      activeIndex = _ref.activeIndex,
      _ref$defaultActiveInd = _ref.defaultActiveIndex,
      defaultActiveIndex = _ref$defaultActiveInd === void 0 ? 0 : _ref$defaultActiveInd,
      _ref$onChange = _ref.onChange,
      onChange = _ref$onChange === void 0 ? function (e) {
    return e;
  } : _ref$onChange;

  var _useState = useState(defaultActiveIndex),
      _useState2 = _slicedToArray(_useState, 2),
      localActiveIndex = _useState2[0],
      setLocalActiveIndex = _useState2[1];

  var _useState3 = useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      activeSectionId = _useState4[0],
      setActiveSectionId = _useState4[1];

  var containerRef = useRef(null);
  var choosenActiveIndex = ['number', 'string'].includes(_typeof(activeIndex)) && activeIndex !== '' ? Number(activeIndex) : localActiveIndex;

  var navigateToSection = function navigateToSection(sectionId) {
    var scroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    if (scroll) {
      var activeImageElement = document.getElementById(sectionId);
      activeImageElement.scrollIntoView({
        behavior: 'smooth'
      });
    }

    setActiveSectionId(sectionId);
  };

  var updateCurrentActiveSection = useMemo(function () {
    return debounce(function () {
      var containerElement = containerRef.current;
      var currentNavigationElement = Children.map(children, function (child) {
        return child;
      }).find(function (_child, childIndex) {
        return childIndex === choosenActiveIndex;
      });
      var currentAnchorMenuList = Array.isArray(currentNavigationElement.props.anchorMenu) ? currentNavigationElement.props.anchorMenu : [];

      if (containerElement && currentAnchorMenuList.length > 0) {
        var currentAnchorElementList = currentAnchorMenuList.map(function (anchorMenu) {
          return document.getElementById(anchorMenu.id);
        });
        var containerRect = containerElement.getBoundingClientRect();
        var containerPosition = {
          top: containerRect.top,
          bottom: containerRect.top + containerRect.height
        };
        var anchorElementHeightList = currentAnchorElementList.map(function (element) {
          if (!element) {
            return false;
          }

          var elementPosition = {
            top: element.getBoundingClientRect().top,
            bottom: element.getBoundingClientRect().top + element.getBoundingClientRect().height
          };
          return Math.min(containerPosition.bottom, elementPosition.bottom) - Math.max(containerPosition.top, elementPosition.top);
        }).filter(Boolean);
        var activeElementIndex = anchorElementHeightList.indexOf(Math.max.apply(Math, _toConsumableArray(anchorElementHeightList)));

        if (activeElementIndex > -1 && activeElementIndex !== activeSectionId) {
          navigateToSection(currentAnchorMenuList[activeElementIndex].id);
        }
      }
    }, 300);
  }, [activeSectionId, choosenActiveIndex, children]);
  useEffect(function () {
    updateCurrentActiveSection();
  }, [choosenActiveIndex, updateCurrentActiveSection]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SideNavigation, null, Children.map(children, function (child, childIndex) {
    return child.type.displayName === 'WithSideNavigationItem' && /*#__PURE__*/React.createElement(SideNavigationItem, {
      active: childIndex === choosenActiveIndex,
      disabled: Boolean(child.props.disabled),
      onClick: function onClick() {
        onChange(childIndex);
        setLocalActiveIndex(childIndex);
      }
    }, child.props.name, childIndex === choosenActiveIndex && /*#__PURE__*/React.createElement(SideNavigationAnchorContainer, null, Array.isArray(child.props.anchorMenu) && child.props.anchorMenu.map(function (anchorMenu) {
      return /*#__PURE__*/React.createElement(SideNavigationAnchorItem, {
        key: anchorMenu.id,
        active: activeSectionId === anchorMenu.id,
        onClick: function onClick() {
          return navigateToSection(anchorMenu.id, true);
        }
      }, anchorMenu.title);
    }), /*#__PURE__*/React.createElement(Space, {
      direction: "vertical",
      size: "small"
    }, child.props.additionalNavigation)));
  })), /*#__PURE__*/React.createElement("div", {
    ref: containerRef,
    style: {
      height: '100%',
      overflow: 'auto'
    },
    onScroll: updateCurrentActiveSection
  }, Children.map(children, function (child, childIndex) {
    return childIndex === choosenActiveIndex && child;
  })));
};

WithSideNavigation.Item = SideNavigationContainer;
WithSideNavigation.Item.displayName = 'WithSideNavigationItem';
export default WithSideNavigation;